import { Box, Grid } from '@mui/material';
import { QuestionnaireResponse } from '../types/MedicalHealthInformation';
import { parseCompleteStatus } from '../func/parse';
import {
  INFO_KUBUN,
  MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME,
  UNANSWERED
} from '../constants/constants';
import { useMedicalHealthInformationContext } from '../Context';
import Card from './Card';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranchQuestionnaireResponse = () => {
  const {
    setActiveStep,
    setDetailStep,
    activeMedicalHealthInformation,
    setActiveQuestionnaireResponse,
    cognitoId,
    setFhirIdForUnmask
  } = useMedicalHealthInformationContext();
  const handleCardClick = (data: QuestionnaireResponse, status: string) => {
    if (status === UNANSWERED) {
      const url = `${import.meta.env.VITE_PMS_URL}/interview/${
        activeMedicalHealthInformation.facility_id
      }/${cognitoId}/${activeMedicalHealthInformation.outpatient_id}/${activeMedicalHealthInformation.reserve_date}/${
        activeMedicalHealthInformation.reserve_time
      }`;
      window.location.href = url;
      return;
    }
    setActiveQuestionnaireResponse(data);
    setFhirIdForUnmask(`QuestionnaireResponse/${data.id}`);
    setDetailStep(MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME);
    setActiveStep(MEDICAL_HEALTH_INFORMATION_DETAIL_NAME);
  };

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            {activeMedicalHealthInformation.questionnaire_response_list.map((data) => {
              const status = parseCompleteStatus(data.complete_flag);
              const label =
                data.information_kbn === INFO_KUBUN['PATIENT']
                  ? '事前問診'
                  : data.information_kbn === INFO_KUBUN['PRACTITIONER']
                    ? '院内問診'
                    : '';
              return <Card key={data.id} onClick={() => handleCardClick(data, status)} label={label} status={status} />;
            })}
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationBranchQuestionnaireResponse;
